"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PureFilterEmptyState = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactIntl = require("react-intl");

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _EmptyState = _interopRequireDefault(require("./EmptyState"));

var _svgs = require("../../lib/svgs");

var _comments = require("../../actions/comments");

var _FilterEmptyState = _interopRequireDefault(require("./FilterEmptyState.scss"));

var _reducers = require("../../reducers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FilterEmptyState = function FilterEmptyState(props) {
  var allScreenCommentsOn = props.allScreenCommentsOn,
      clearFilter = props.clearFilter;
  return /*#__PURE__*/_react.default.createElement(_EmptyState.default, {
    className: (0, _classnames.default)(_FilterEmptyState.default.component, _defineProperty({}, _FilterEmptyState.default.globalEmptyStateContent, allScreenCommentsOn))
  }, /*#__PURE__*/_react.default.createElement(_EmptyState.default.Illustration, null, _svgs.FilterIllustration), /*#__PURE__*/_react.default.createElement(_EmptyState.default.Title, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.list.no-filter-result-title"
  })), /*#__PURE__*/_react.default.createElement(_EmptyState.default.Subtitle, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.list.no-filter-result-body"
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _FilterEmptyState.default.clearLink,
    id: "no-filter-result-clear-link",
    onClick: clearFilter
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.list.no-filter-result.clear"
  })));
};

exports.PureFilterEmptyState = FilterEmptyState;
FilterEmptyState.defaultProps = {
  allScreenCommentsOn: false,
  clearFilter: function clearFilter() {}
};
FilterEmptyState.propTypes = {
  allScreenCommentsOn: _propTypes.default.bool,
  clearFilter: _propTypes.default.func
};
var mapDispatchToProps = {
  clearFilter: _comments.commentsFilterClear
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps, undefined, {
  context: _reducers.reduxContext
})(FilterEmptyState);

exports.default = _default;